import ClickOutside from "vue-click-outside";
import { getReadableOppositeColor } from "@Broker/js/custom/utils";
import DocumentTagsSelect from "@Broker/@Modules/clients/applications/documents/components/documents-page/document-classification/document-listing/document-tags-select.vue";
import * as DocumentsGetters from "@Broker/@Modules/clients/applications/documents/store/documents-getters";
import * as DocumentsActions from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import { computed, defineComponent, toRefs, ref } from "@vue/composition-api";
import { useDocumentsStoreActions, useDocumentsStoreGetters } from "@Broker/@Modules/clients/applications/documents/store/document-helpers";
import { useI18n } from "vue-i18n-composable";
import { isEmpty } from "lodash";
export default defineComponent({
  name: "DocumentTags",
  components: {
    DocumentTagsSelect
  },
  directives: {
    ClickOutside
  },
  props: {
    applicationId: {
      type: [String, Number],
      required: true
    },
    document: {
      type: Object,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const {
      applicationId,
      document
    } = toRefs(props);
    const showingTagsSelector = ref(false);
    const showUserLabels = ref(true);
    const disabledSelect = ref(false);
    const tagsPopover = ref();
    const addTagsTarget = ref({});
    const {
      ATTACH_DOCUMENT_LABEL,
      REMOVE_LABEL_FROM_DOCUMENT
    } = useDocumentsStoreActions([DocumentsActions.ATTACH_DOCUMENT_LABEL, DocumentsActions.REMOVE_LABEL_FROM_DOCUMENT]);
    const {
      DOCUMENT_LABELS
    } = useDocumentsStoreGetters([DocumentsGetters.DOCUMENT_LABELS]);
    const tags = computed(() => DOCUMENT_LABELS.value({
      applicationId: applicationId.value,
      documentId: document.value.documentId
    }));
    const areTagsEmpty = computed(() => isEmpty(tags.value));
    const switchText = computed(() => showUserLabels.value ? t("documents.showUserLabels") : t("documents.showBrokerageLabels"));
    const removeLabel = async label => {
      await REMOVE_LABEL_FROM_DOCUMENT({
        applicationId: applicationId.value,
        documentId: document.value.documentId,
        label
      });
      disabledSelect.value = false;
    };
    const handleSelect = async ({
      label,
      action
    }) => {
      if (label.id === "no-results-btn") {
        emit("close");
        handleClickOutside();
        return emit("open-tags", label.name);
      }
      disabledSelect.value = false;
      if (action === "unselect") return await removeLabel(label);
      await ATTACH_DOCUMENT_LABEL({
        applicationId: applicationId.value,
        documentId: document.value.documentId,
        label
      });
      disabledSelect.value = false;
    };
    const isAlreadyAttached = id => tags.value.some(tag => tag.id === id);
    const handleClickOutside = () => {
      var _tagsPopover$value;
      (_tagsPopover$value = tagsPopover.value) == null ? void 0 : _tagsPopover$value.$emit("close");
    };
    return {
      showingTagsSelector,
      showUserLabels,
      disabledSelect,
      ATTACH_DOCUMENT_LABEL,
      REMOVE_LABEL_FROM_DOCUMENT,
      DOCUMENT_LABELS,
      tags,
      areTagsEmpty,
      switchText,
      addTagsTarget,
      tagsPopover,
      removeLabel,
      handleSelect,
      isAlreadyAttached,
      handleClickOutside,
      getReadableOppositeColor
    };
  }
});